import shoppingListReducer from './shoppingList.reducer';
export default shoppingListReducer;

export * from './shoppingList.selectors';
